var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.969487 9.94252C0.676593 10.2354 0.676593 10.7103 0.969487 11.0032C1.26238 11.2961 1.73726 11.2961 2.03015 11.0032L5.98636 7.04699L9.96986 11.0305C10.2628 11.3234 10.7376 11.3234 11.0305 11.0305C11.3234 10.7376 11.3234 10.2627 11.0305 9.96981L7.04703 5.98633L11.0031 2.03033C11.296 1.73743 11.296 1.26256 11.0031 0.969669C10.7102 0.676777 10.2353 0.676777 9.9424 0.969669L5.98636 4.92568L2.05762 0.996952C1.76472 0.70406 1.28985 0.70406 0.996953 0.996952C0.704059 1.28984 0.704059 1.76472 0.996953 2.05761L4.9257 5.98633L0.969487 9.94252Z",
    fill: "#6D6970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.9c91c028b7864e9703718d7728f54167.svg";
export { ForwardRef as ReactComponent };